import API from './apiConfig';

const TRANSACTION_API = '/transactions';
export const getTranscationData = async (filter) => {
  const response = await API.post('/transactionData', filter, {
    withCredentials: true,
  });
  return response.data;
};

export const getTranscations = async (filter) => {
  const response = await API.get(TRANSACTION_API + '/filteredTransactions', {
    withCredentials: true,
    params: filter,
  });
  return response.data;
};

export const getDownloadTemplate = async (filter) => {
  const response = await API.get(TRANSACTION_API + '/exportCSV', {
    headers: {
      'Content-Type': 'application/json',
    },
    params: filter,
    responseType: 'blob',
    withCredentials: true,
    timeout: 1000 * 60 * 15,
  });
  return response.data;
};

export const updateTransactionStatus = async (
  transactionId,
  filterRequest,
  status,
) => {
  const res = await API.post(TRANSACTION_API + '/updateStatus', {
    transactionId,
    filterRequest,
    status,
  });
  return res.data;
};

export const getInvoiceByTransactionId = async (transactionId) => {
  const res = await API.get(TRANSACTION_API + '/getInvoice', {
    params: {
      transactionId,
    },
  });
  return res.data;
};

export const getSearch = async (payload) => {
  const res = await API.get(TRANSACTION_API + '/search', {
    withCredentials: true,
    params: payload,
  });
  return res.data;
};
